"use client";

import { useEffect } from "react";

export default function PWAInstallProvider() {
  useEffect(() => {
    const handler = (e: Event) => {

      e.preventDefault();
    
      (window as any).deferredPrompt = e;
    };

    window.addEventListener("beforeinstallprompt", handler as EventListener);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler as EventListener);
    };
  }, []);

  return null;
}
